import { restResourceRequester } from "../rest-resource-requester";
import { GetHomeMenuDataListRequest, GetHomeMenuDataListResponse } from ".";
import { stringify } from "../../util/querystring-util";

interface HomeRestResource {
  getHomeMenuDataList(
    request: GetHomeMenuDataListRequest,
  ): Promise<GetHomeMenuDataListResponse>;
}

/**
 * GET /
 */
const getHomeMenuDataList = restResourceRequester<
  GetHomeMenuDataListRequest,
  GetHomeMenuDataListResponse
>("GET", (request) => {
  const queryParameters = {
    dfnSetVerNum: request.dfnSetVerNum,
  };
  return `/menu/my-projects-todo-list?${stringify(queryParameters)}`;
});

export const HomeRestResource: HomeRestResource = {
  getHomeMenuDataList: getHomeMenuDataList,
};
